/**
 * Sélecteur de la SOURCE du corrigé (phase Corrigé V2) : génération depuis
 * l'énoncé, ou dictée orale structurée par l'IA. Partagé wizard ⇄ éditeur.
 */

import { FileText, Mic } from 'lucide-react';
import { cn } from '@jeraisonne/ui';

export type SolutionSource = 'generate' | 'dictation';

export interface SolutionSourceToggleProps {
  value: SolutionSource;
  onChange: (v: SolutionSource) => void;
  disabled?: boolean;
}

const OPTIONS: { value: SolutionSource; label: string; icon: typeof FileText }[] = [
  { value: 'generate', label: 'Depuis l’énoncé', icon: FileText },
  { value: 'dictation', label: 'Dicter', icon: Mic },
];

export function SolutionSourceToggle({
  value,
  onChange,
  disabled = false,
}: SolutionSourceToggleProps) {
  return (
    <div className="border-ink-200 grid grid-cols-2 gap-1 rounded-xl border bg-white p-1">
      {OPTIONS.map((opt) => {
        const Icon = opt.icon;
        const active = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            disabled={disabled}
            aria-pressed={active}
            className={cn(
              'flex min-h-11 items-center justify-center gap-1.5 rounded-lg px-2 font-sans text-[13px] font-semibold transition-colors active:scale-[0.98] disabled:opacity-50',
              active ? 'bg-primary-500 text-white' : 'text-ink-600 hover:bg-ink-50',
            )}
          >
            <Icon className="h-4 w-4" />
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
